var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWithNumActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 14.3335V20.6668M12.333 17.5002H18.6663M23.4163 17.5002C23.4163 21.8724 19.8719 25.4168 15.4997 25.4168C11.1274 25.4168 7.58301 21.8724 7.58301 17.5002C7.58301 13.1279 11.1274 9.5835 15.4997 9.5835C19.8719 9.5835 23.4163 13.1279 23.4163 17.5002Z",
    stroke: "#0092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 3.12598V11H22.7769V5.03809C22.6838 5.12044 22.5728 5.19922 22.4438 5.27441C22.3185 5.34603 22.1842 5.41227 22.041 5.47314C21.8978 5.53044 21.7492 5.58057 21.5952 5.62354C21.4412 5.66292 21.2891 5.69157 21.1387 5.70947V4.28076C21.5791 4.15186 21.9945 3.98714 22.3848 3.78662C22.7751 3.5861 23.1278 3.36589 23.4429 3.12598H24.4688Z",
    fill: "#0092DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWithNumActive);
export default __webpack_public_path__ + "static/media/plus_with_num_active.1dd3dd7d95718dfeaf3fcd346cb5726c.svg";
export { ForwardRef as ReactComponent };